import { registerEnumSet } from '@if/mui'
import { CircleCheck, CircleX } from 'lucide-react'

/**
 * The outcome of one command execution. The API records an error message rather than a
 * status, so the value is derived from it — but the presentation still comes from the one
 * registry every chip in the app reads.
 */
export enum EDevToolsExecutionStatus {
  Success = 'success',
  Failed = 'failed',
}

registerEnumSet(EDevToolsExecutionStatus, {
  success: { color: 'success', icon: CircleCheck, labelKey: 'admin.devTools.history.status.success' },
  failed: { color: 'error', icon: CircleX, labelKey: 'admin.devTools.history.status.failed' },
})
